<template>
  <div>
    <b-card no-body class="rounded-xl border-none">
      <div class="mt-8">
        <b-input-group>
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="PurchaseHistoryData"
        >
          <el-table-column
            label="Amount"
            min-width="120px"
            prop="amount"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.amount }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Credit/Debit"
            min-width="140px"
            prop="cardbill	"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.cardbill }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Remark"
            min-width="220px"
            prop="remark"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.remark }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Credit Date"
            min-width="220px"
            prop="creditcard"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.creditcard }}</span>
            </template>
          </el-table-column>

          <el-table-column label="IP" min-width="220px" prop="ip" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.ip }}</span>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import PurchaseHistoryData from "./PurchaseHistoryData";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      PurchaseHistoryData,
      currentPage: 1,
      isDetailsActive: false,
      isShowCreate: false,
    };
  },
  methods: {
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
